import { OutlinedInput, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useCallback, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { IProductParams } from "../../../model";
import { appLogger } from "../../../utils";
import useClickOutside from "./useClickOutside";

const BrandingInputField = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "BrandingInputField",
      component: "add-product",
      fileName: "BrandingInputField.tsx",
      prpos: props,
    },
  });

  const { productParams, setProductParams, field, fieldValue } = props;
  const handleInputChange = (event: any) => {
    let fieldValue = event.target.value;
    if (productParams && productParams.products[0] && productParams.products[0].technology == "rokuTv") {
      fieldValue = typeof fieldValue == "string" ? fieldValue.replace("px", "") : fieldValue;
    }
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.branding) {
          temp.products[0].feedbackAgentSettings.branding = {};
        }
        if (field == "Input Border Radius") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-input-border-radius"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "Card Border Radius") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-card-border-radius"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "CommentsField Height") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-comments-field-height"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "Banner Font Family") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-editor-font-family"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "Primary Button Border Radius") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-primary_btn-border-radius"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "Secondary Button Border Radius") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-secondary_btn-border-radius"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "URI of Selected Start Rating") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-selected-start-rating-uri"
          ] = fieldValue;
          setProductParams(temp);
        } else if (field == "URI of Unselected Start Rating") {
          temp.products[0].feedbackAgentSettings.branding[
            "branding-cuvo-unselected-start-rating-uri"
          ] = fieldValue;
          setProductParams(temp);
        }
      }
    }
  };

  return (
    <>
      {/* ******************Form Appreance******************************** */}

      <FormControl className="custom-select" fullWidth>
        <InputLabel>
          {" "}
          {(field.split(" ")[0] == "Main" || field.split(" ")[0] == "Card" || field.split(" ")[0] == "URI") ? field : field.substr(field.indexOf(" ") + 1)}
        </InputLabel>
        <OutlinedInput
          type="text"
          id={`border_radius_${field}`}
          value={fieldValue}
          label="flow"
          onChange={(e) => handleInputChange(e)}
        ></OutlinedInput>
      </FormControl>
      {field == "CommentsField Height" && (
        <Typography className="fullwidth" sx={{ fontSize: "9px", mt: 0.7 }}>
          (This field will not apply in preview)
        </Typography>
      )}
      {/* *****************Form Appreance************************************** */}
    </>
  );
};

export default BrandingInputField;
